import { ReactNode } from "react";

interface LandingModelSupportProps {
    title: string;
    children: ReactNode;
}

export const LandingModelSupport = ({ title, children }: LandingModelSupportProps) => {
    return (
        <section className="py-20 border-t border-gray-200 dark:border-gray-900 bg-white dark:bg-gray-900/50">
            <div className="container mx-auto px-4 text-center">
                <p className="text-gray-500 font-medium mb-8 uppercase tracking-widest text-sm">{title}</p>
                <div className="flex flex-wrap justify-center items-center gap-12 grayscale opacity-70 hover:grayscale-0 hover:opacity-100 transition-all duration-500">
                    {children}
                </div>
            </div>
        </section>
    );
};
